import { getSessionStorageValue, removeSessionStorageValue, setSessionStorageValue } from '@/helpers/util';

export const CELEBRATION_SESSION_DATA = 'celebrationData';

export const setOrUpdateCelebrationInfoInSession = (celebrations) => {
  setSessionStorageValue(CELEBRATION_SESSION_DATA, celebrations);
};

export const removeCelebrationInfoFromSession = () => {
  removeSessionStorageValue(CELEBRATION_SESSION_DATA);
};

export const getCelebrationsInfoSession = () => {
  return getSessionStorageValue(CELEBRATION_SESSION_DATA);
};
